/**
 * Stable fallbacks for a flow's path lists. A flow without rule groups has no
 * `pathGroups` (the Voluum mapper omits an empty list); a fresh `[]` per
 * render re-derived the paths on every render, so the Flows-tab draft reset
 * itself in a loop (React "Maximum update depth") and switched-off paths
 * snapped back on.
 * For Media Devoted | Created By Ciro Autiero
 */

import type { Flow } from '@/hooks';

export const NO_PATHS: NonNullable<Flow['defaultPaths']> = [];
export const NO_GROUPS: NonNullable<Flow['pathGroups']> = [];
